export default function InfoandSupport() {
  return (
    <div>
      <p>
        For any issue concerning the REST API of DISGENET, please contact{' '}
        <a href="mailto:info@disgenet.com" title="copy">
          info@disgenet.com
        </a>
        .
      </p>
    </div>
  );
}
